import React, { Fragment } from 'react';
import EnhancedModal from '../../../../../components/enhanced-modal';
import { Button, Card } from 'antd';
import { MODAL_WIDTH_LG } from '../../../../../styles/constants';
import { compose } from 'redux';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { changeLanguage, hideDsdComponentModal, updateCodelist, readComponentCodelistCodesItemsPage } from '../actions';
import ItemList from "../../../../../components/item-list";


const mapStateToProps = (state) => ({
    columnCodelist: state.scenes.mappingHandler.mappingSet.transcoding.columnCodelist,
    DSDcomponent: state.scenes.mappingHandler.mappingSet.transcoding.DSDcomponent,
    data: state.scenes.mappingHandler.mappingSet.transcoding.data,
    modalLanguage: state.scenes.mappingHandler.mappingSet.transcoding.modalLanguage,
    rows: state.scenes.mappingHandler.mappingSet.transcoding.rows,
    componentCodelistCodesItemsPage: state.scenes.mappingHandler.mappingSet.transcoding.componentCodelistCodesItemsPage,
    componentCodelistCodesItemsCount: state.scenes.mappingHandler.mappingSet.transcoding.componentCodelistCodesItemsCount
})

const mapDispatchToProps = dispatch => ({
    onUpdateCodelist: (codelist) => dispatch(updateCodelist(codelist)),
    onHideDsdComponentModal: () => dispatch(hideDsdComponentModal()),
    onLanguageChange: (lang) => dispatch(changeLanguage(lang)),
    fetchCodelistCodesItemsPage:({pageNum, pageSize, searchText, filters, sortCol, sortByDesc, codelist, modalLanguage}) => dispatch(readComponentCodelistCodesItemsPage(pageNum, pageSize, searchText, filters, sortCol, sortByDesc, codelist, modalLanguage))
})

const DSDComponentModal = ({
    t,
    onUpdateCodelist,
    columnCodelist,
    DSDcomponent,
    data,
    onHideDsdComponentModal,
    modalLanguage,
    onLanguageChange,
    fetchCodelistCodesItemsPage,
    componentCodelistCodesItemsPage,
    componentCodelistCodesItemsCount
}) => {

    return(
        !!data && data.dsdCodelist &&
        <EnhancedModal 
                title={`Codelist [${data.dsdCodelist.id}+${data.dsdCodelist.agencyID}+${data.dsdCodelist.version}] ${data.dsdColumnName}`}
                visible={DSDcomponent !== null}
                footer={
                    <Fragment>
                        <Button
                            onClick={() => {onHideDsdComponentModal()}}>
                                {t('commons.buttons.close.title')}
                        </Button>
                    </Fragment>}
                onCancel={() => {onHideDsdComponentModal()}}
                width={MODAL_WIDTH_LG}
                withDataLanguageSelector
                onDataLanguageSelectorChange={
                    (lang, changeLang) => {
                      onLanguageChange(lang);
                      changeLang();
                    }
                }
            >
                {!!columnCodelist &&
                <Card>
                    <ItemList
                    data={componentCodelistCodesItemsPage || null}
                    rowCount={componentCodelistCodesItemsCount}
                    isPaginated
                        onRowClick={(codelist) => {
                            onUpdateCodelist(codelist);
                            onHideDsdComponentModal();
                        }}
                    onChange={
                      ({pageNum, pageSize, searchText, filters, sortCol, sortByDesc}) =>
                      fetchCodelistCodesItemsPage({
                          pageNum,
                          pageSize,
                          searchText,
                          filters,
                          sortCol,
                          sortByDesc,
                          codelist: data.dsdCodelist,
                          modalLanguage
                        })
                    }
                    />
                </Card>
                }                    
            </EnhancedModal>
    )
}

export default compose(
    translate(),
    connect(mapStateToProps, mapDispatchToProps)
)(DSDComponentModal)
